module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAMAAACAAGUXAAAATlBMVEUAAACgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCioqKioqKgoKCgoKChoaGgoKCgoKCfn5+goKCgoKCgoKChoaGgoKChoaGfn5+fn5+goKA0cGlSAAAAGXRSTlMA6d6Z93dmsIQXDfG706VwWSbMjUw9xjYtHD/d2QAAAMFJREFUKM9tkQkOhCAMRT+LbO7j2vtfdKARReJLLElfrf4AZlW9Ji2HCTWbpIwwb+WoxIZCNbEhLff7LpbuUWdqzjwhgCRHZFRyK4ZY9Rx6HskISmi6DqmcO/InqeRnlOCzCbVTyxNmBbA/arBUMAHmGeU0riVqnUx/BvzujZID2LiAIynAy8uNqbS817ZXFt8RY6gCEfPtRHK7GM+pWTb5dguAkO9ler/mUaJKdeBNo281o8a7PgXptMAnPsRHbcAfukUetNxATKYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer/footer_gray_wchat@2x.png
// module id = 5wVY
// module chunks = 15